import React from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import { createStructuredSelector } from 'reselect';
import injectReducer from 'utils/injectReducer';
import injectSaga from 'utils/injectSaga';
import { connect } from 'react-redux';
import { compose } from 'redux';
import reducer from './reducer';
import saga from './saga';
import { FILTERS_ALLOWED, FILTERS_LABELS, FILTERS_LABELS_SHORT, FILTERS_AS_TAG } from './constants';
import { getObjByAttribute } from '../../utils/common';
import Loader from '../Loader';
import { Checkbox } from 'antd';
import { default as PrescoringFilter } from '../PrescoringTool/filter';

import { CONTRACTUAL_CATEGORIES } from 'containers/App/contractualCategories';

import { makeSelectParam, makeSelectSelectedParams, makeSelectLoading, makeSelectLabels } from './selectors';
import { makeSelectFiltersOption, transformSelectedFiltersForQuesystring } from '../HorizontalFilter/selectors';
import { makeSelectTags } from '../HorizontalFilter/selectors';
import { makeSelectCheckResponse, makeSelectCheckInputData } from '../PrescoringTool/selectors'
import { featureAllowed } from 'containers/App/selectors';
import { getFilters, updateParam, removeParam } from './actions';
import {
  addOption,
  hideTag,
  removeOption,
  showTag,
} from '../HorizontalFilter/actions';
import {
  ChoiceFilter,
  SelectCollapsibleFilter,
  RangeSliderFilter,
  MultiselectFilter,
  MultiselectWithSwitchFilter,
  MultiselectWithIconFilter,
} from '../SearchFilters/';

import './styles.scss';
import _ from 'lodash';

class Search extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      qsFiltersSetted: false
    };
    this.id = _.uniqueId("Search-");
  }

  componentDidMount() {
    this.props.loadFilters();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.params.hasOwnProperty('brands')) {
      const {
        selectedTags,
        activeFilters,
        selectedParams,
        params
      } = this.props;

      if (!prevState.qsFiltersSetted) {
        const qsFilters = queryString.parse(location.search, {arrayFormat: 'comma'});

        if (Object.keys(qsFilters).length) {
          for (const [filterKey, filterValue] of Object.entries(qsFilters)) {
            if (FILTERS_ALLOWED.indexOf(filterKey) >= 0) {
              if (FILTERS_AS_TAG.indexOf(filterKey) >= 0) {
                this.props.addOption(filterKey, FILTERS_LABELS[filterKey]);
                this.props.hideTag(filterKey);
              } else {
                this.props.updateValue({
                  name: filterKey,
                  label: FILTERS_LABELS[filterKey],
                  value: (
                            typeof params[filterKey] !== 'undefined'
                            && Array.isArray(params[filterKey])
                            && !Array.isArray(filterValue)
                          )
                          ? [filterValue]
                          : filterValue,
                });
                this.props.loadFilters();
              }
            }
          }
        }

        this.setState({qsFiltersSetted: true});
      }

      const selected = [...selectedTags, ...activeFilters];
      const transformedParams = transformSelectedFiltersForQuesystring(selected);
      let qs = queryString.stringify(transformedParams, {arrayFormat: 'comma'})
      let qs2 = queryString.parse(transformedParams, {arrayFormat: 'comma'});
      const cleanSearch = location.search.replace('?', '');

      let { prescoringResponse, prescoringInputData } = this.props;
      prescoringResponse = prescoringResponse.hasOwnProperty('_root') ? prescoringResponse.toJS() : prescoringResponse;
      prescoringInputData = prescoringInputData.hasOwnProperty('_root') ? prescoringInputData.toJS() : prescoringInputData;

      const customerType = prescoringInputData.contractualCategory ?
        this.getCustomerTypeByContractualCategory(prescoringInputData.contractualCategory)
        : null;

      if (
        customerType &&
        !selectedParams.some(selectedParam => selectedParam.name === "monthly_rate")
        && !selectedParams.some(selectedParam => selectedParam.name === "deposit")
        && (
          (customerType !== 'privati' && !selectedTags.some(selectedTag => selectedTag.value === 'privati'))
          ||
          (customerType !== 'piva' && !selectedTags.some(selectedTag => selectedTag.value === 'piva'))
        )
        ) {
          let needFetchFilters = false;

          const currentCustomerTypePrivati = selectedTags.some(selectedTag => selectedTag.value === 'privati');
          const currentCustomerTypePiva = selectedTags.some(selectedTag => selectedTag.value === 'piva');

          if (!currentCustomerTypePrivati && customerType === 'privati') {
            qs2.privati = 1;
            needFetchFilters = true;
          } else if (!currentCustomerTypePiva && customerType === 'piva') {
            qs2.piva = 1;
            needFetchFilters = true;
          } else if (!currentCustomerTypePiva && currentCustomerTypePrivati) {
            qs2.privati = 1;
            needFetchFilters = true;
          } else if (currentCustomerTypePiva && !currentCustomerTypePrivati) {
            qs2.piva = 1;
            needFetchFilters = true;
          }

          if (prescoringResponse.monthlyRateMax > 0) {
            const currentMonthlyRate = selectedParams.find(currentParam => currentParam.name === 'monthly_rate');
            let monthlyRateMin;

            if (currentMonthlyRate) {
              monthlyRateMin = currentMonthlyRate.value[0];
            } else {
              monthlyRateMin = params.monthly_rates ? params.monthly_rates.min : 0;
            }

            qs2.monthly_rate = [monthlyRateMin, parseInt(prescoringResponse.monthlyRateMax)]
            needFetchFilters = true;
          }

          if (prescoringResponse.depositRequired === true) {
            const currentDeposit = selectedParams.find(currentParam => currentParam.name === 'deposit');
            let depositMax;

            if (currentDeposit) {
              depositMax = currentDeposit.value[1];
            } else {
              depositMax = params.deposits ? params.deposits.max : 0;
            }

            qs2.deposit = [1, depositMax]
            needFetchFilters = true;
          }

          if (needFetchFilters) {
            qs = queryString.stringify(qs2, {arrayFormat: 'comma'})
          }
      }

      if (cleanSearch != qs) {
        const newurl = `${location.protocol}//${location.host}${location.pathname}?${qs}`;
        history.pushState({path:newurl}, '', newurl);
      }
    }
  }

  getCustomerTypeByContractualCategory = contractualCategory => {
    const contractualCategoryFound = CONTRACTUAL_CATEGORIES.find(contractualCategoryItem => contractualCategoryItem.value === contractualCategory);

    if (contractualCategoryFound) {
      return contractualCategoryFound.type === 'BUSINESS' ? 'piva' : 'privati';
    }

    return null;
  }

  onRangeChange = (label, name, start, end) => {
    this.props.updateValue({
      name,
      label,
      value: [start, end],
    });

    this.props.loadFilters();
  };

  onFastDeliveryChange = (checked) => {
    if (!checked) {
      this.props.removeOption('fast_delivery');
      this.props.showTag('fast_delivery');
    } else {
      this.props.addOption('fast_delivery', FILTERS_LABELS.fast_delivery);
      this.props.hideTag('fast_delivery');
      this.props.removeParam('delivery_time');
    }
  };

  render() {
    const { params, selectedParams, selectedTags, tags, loading } = this.props;
    let { prescoringResponse } = this.props;
    prescoringResponse = prescoringResponse.hasOwnProperty('_root') ? prescoringResponse.toJS() : prescoringResponse;

    if (!params.hasOwnProperty('brands')) {
      return <Loader loading={true} message=" " />;
    }

    const {
      brands,
      brokers,
      categories,
      deposits,
      distances,
      durations,
      fuels,
      gear,
      monthly_rates,
      kwh_range,
      delivery_times,
      products,
      stocks,
      areas,
    } = params;

    const getSelectedParamValue = (paramName, paramValuesName) => {
      const current = getObjByAttribute(selectedParams, 'name', paramName)

      if (current && current.value) {
        return current.value
      }

      if (params[paramValuesName]) {
        if (typeof params[paramValuesName].min !== 'undefined') {
          return [params[paramValuesName].min, params[paramValuesName].max]
        }

        const [start, end] = [Object.keys(params[paramValuesName])[0], Object.keys(params[paramValuesName]).slice(-1)[0]]

        return [
          parseInt(start),
          parseInt(end)
        ]
      }

      return [0, 0]
    }

    const hasConfirmMessage = prescoringResponse && prescoringResponse.hasOwnProperty('chance') && prescoringResponse.chance !== null;

    const fastDeliverySelected = selectedTags && selectedTags.some(tag => tag.value === 'fast_delivery');

    return (
      <div id={this.id} className="todo-sidebar search position-relative">
        <Loader loading={loading} />
        <PrescoringFilter />
        <ChoiceFilter label="Tipologia cliente" tags={tags} hasConfirmMessage={hasConfirmMessage} />
        {(monthly_rates && monthly_rates.min >= 0 && monthly_rates.max >= 0) ?
          <RangeSliderFilter
            name="monthly_rate"
            label={FILTERS_LABELS.monthly_rate}
            min={monthly_rates.min}
            max={monthly_rates.max}
            unit={monthly_rates.unit}
            step={undefined}
            value={getSelectedParamValue('monthly_rate', 'monthly_rates')}
            key={`monthly_rate${getSelectedParamValue('monthly_rate', 'monthly_rates')}`}
            onChange={this.onRangeChange}
            withInput
            withStepLabel={false}
            labelFormatter={(value, unit) => `${unit} ${value.toLocaleString('it')}`}
            hasConfirmMessage={hasConfirmMessage}
          />
        : null}
        {(deposits && deposits.min !== undefined && deposits.max !== undefined) ?
          <RangeSliderFilter
            name="deposit"
            label={FILTERS_LABELS.deposit}
            min={deposits.min}
            max={deposits.max}
            unit={deposits.unit}
            step={undefined}
            value={getSelectedParamValue('deposit', 'deposits')}
            key={`deposit${getSelectedParamValue('deposit', 'deposits')}`}
            onChange={this.onRangeChange}
            withInput
            withStepLabel={false}
            labelFormatter={(value, unit) => `${unit} ${value.toLocaleString('it')}`}
            hasConfirmMessage={hasConfirmMessage}
          />
        : null}
        {durations && Object.keys(durations).length > 0 &&
          <RangeSliderFilter
            name="duration"
            label={FILTERS_LABELS.duration}
            items={{...durations}}
            unit="mesi"
            step={null}
            value={getSelectedParamValue('duration', 'durations')}
            key={`duration${getSelectedParamValue('duration', 'durations')}`}
            onChange={this.onRangeChange}
            // withInput
            withStepLabel={false}
          />
        }
        {distances && Object.keys(distances).length > 0 &&
          <RangeSliderFilter
            name="distance"
            label={FILTERS_LABELS.distance}
            items={{...distances}}
            unit="Km"
            step={null}
            value={getSelectedParamValue('distance', 'distances')}
            key={`distance${getSelectedParamValue('distance', 'distances')}`}
            onChange={this.onRangeChange}
            withStepLabel={false}
            labelFormatter={(value, unit) => `${value.toLocaleString('it')} ${unit}`}
          />
        }
        <RangeSliderFilter
          name="delivery_time"
          label={FILTERS_LABELS.delivery_time}
          labelShort={FILTERS_LABELS_SHORT.delivery_time}
          items={{...delivery_times}}
          value={getSelectedParamValue('delivery_time', 'delivery_times')}
          key={`delivery_time${getSelectedParamValue('delivery_time', 'delivery_times')}`}
          onChange={this.onRangeChange}
          step={1}
          withStepLabel={false}
          disabled={fastDeliverySelected}
          addOn={
            <Checkbox
              checked={fastDeliverySelected}
              onChange={e => this.onFastDeliveryChange(e.target.checked)}
            >
              {FILTERS_LABELS.fast_delivery}
            </Checkbox>
          }
        />

        {stocks && stocks.length > 1 &&
          <MultiselectFilter
            label={FILTERS_LABELS.stocks}
            options={stocks}
            name="stocks"
          />
        }

        {brokers.length > 1 &&
          <MultiselectFilter label={FILTERS_LABELS.brokers} options={brokers} name="brokers" />
        }

        {products.length > 1 ?
          <MultiselectFilter label={FILTERS_LABELS.products} options={products} name="products" />
          : null
        }

        <MultiselectWithIconFilter
          label={FILTERS_LABELS.brands}
          options={brands}
          name="brands"
        />

        <MultiselectFilter
          label={FILTERS_LABELS.categories}
          options={categories}
          name="categories"
        />

        <MultiselectFilter label={FILTERS_LABELS.fuels} options={fuels} name="fuels" />

        <SelectCollapsibleFilter label={FILTERS_LABELS.gear} options={gear} name="gear" show={false}/>

        <MultiselectWithSwitchFilter
          label="Neopatentato"
          name="noviceDriver"
          items={[
            {
              label: FILTERS_LABELS.noviceDriver,
              value: 'noviceDriver'
            }
          ]}
        />

        {areas && areas.length > 1 &&
          <MultiselectFilter
            label={FILTERS_LABELS.areas}
            options={areas}
            name="areas"
          />
        }

        {this.props.featureAllowed('catalog') &&
          <MultiselectWithSwitchFilter
            label="Catalogo"
            name="tags"
            items={[
              {
                label: FILTERS_LABELS.catalogo,
                value: 'catalogo'
              }
            ]}
          />
        }

        {/* <SelectCollapsibleFilter
          label={FILTERS_LABELS.kwh}
          options={kwh_range}
          name="kwh"
        /> */}
      </div>
    );
  }
}

Search.defaultProps = {};

Search.propTypes = {
  loadFilters: PropTypes.func.isRequired,
};

const mapStateToProps = createStructuredSelector({
  params: makeSelectParam(),
  selectedParams: makeSelectSelectedParams(),
  selectedTags: makeSelectFiltersOption(),
  activeFilters: makeSelectLabels(),
  tags: makeSelectTags(),
  loading: makeSelectLoading(),
  prescoringResponse: makeSelectCheckResponse(),
  prescoringInputData: makeSelectCheckInputData(),
  featureAllowed: (state, featureSlug) => featureAllowed(state, featureSlug),
});

export function mapDispatchToProps(dispatch) {
  return {
    loadFilters: () => dispatch(getFilters()),
    updateValue: values => dispatch(updateParam(values)),
    addOption: (value, label) => dispatch(addOption(value, label)),
    hideTag: value => dispatch(hideTag(value)),
    removeOption: value => dispatch(removeOption(value)),
    removeParam: name => dispatch(removeParam(name)),
    showTag: value => dispatch(showTag(value)),
  };
}

const withReducer = injectReducer({ key: 'search', reducer });
const withSaga = injectSaga({ key: 'search', saga });

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withReducer,
  withSaga,
  withConnect,
)(Search);

